import gql from "graphql-tag";
const invokeAnalyzeResults = gql(` 
query invokeAnalyzeResults($params: AWSJSON!) {
  invokeAnalyzeResults(params: $params) {
  result
  }
}
`)
export default invokeAnalyzeResults;
